import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkButton, PrimaryButton } from '@/components/ui/buttons';
import { IconScout } from '@/components/ui/images/IconScout';
import { Text } from '@/components/ui/text/Text';
import { colors } from '@/assets/styles/colors';


export interface MonitoringRefreshBarProps {
  /** Última actualización ya formateada; vacío mientras no haya ocurrido ninguna. */
  lastUpdateLabel: string;
  canManualRefresh: boolean;
  onManualRefresh: () => void;
  /** `false` cuando la consulta no retornó colaboradores. */
  canExport: boolean;
  isExporting: boolean;
  onExport: () => void;
}

// Barra de acciones del monitoreo: refresco, sello de última actualización y descarga a Excel.
export const MonitoringRefreshBar: React.FC<MonitoringRefreshBarProps> = ({
  lastUpdateLabel,
  canManualRefresh,
  onManualRefresh,
  canExport,
  isExporting,
  onExport,
}) => {
  const { t: translate } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-4" data-testid="monitoring-refresh-bar">
      <PrimaryButton
        variant="outline"
        size="sm"
        onClick={onManualRefresh}
        iconRight={<IconScout name="sync" />}
        disabled={!canManualRefresh}
        data-testid="monitoring-refresh-button"
      >
        {translate('attendance:monitoring.refresh.action')}
      </PrimaryButton>

      {lastUpdateLabel && (
        <div className="flex items-center gap-2">
          <IconScout name="info" size="sm" color={colors.grays.neutral99} />
          <Text
            variant="small-regular"
            color={colors.grays.neutral66}
            data-testid="monitoring-last-update"
          >
            {translate('attendance:monitoring.refresh.lastUpdate', { datetime: lastUpdateLabel })}
          </Text>
        </div>
      )}

      <div className="ml-auto" data-testid="monitoring-export-button">
        <LinkButton
          iconLeft="import"
          onClick={onExport}
          isLoading={isExporting}
          disabled={!canExport || isExporting}
        >
          {translate('attendance:monitoring.export.action')}
        </LinkButton>
      </div>
    </div>
  );
};

export default MonitoringRefreshBar;
